import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@afzalmedicalcomplex.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-red-50 via-white to-blue-50 px-4">
      <div className="w-full max-w-md card-medi p-10" data-testid="admin-login-card">
        <div className="flex items-center gap-3 mb-8">
          <img src="/amc-logo.png" alt="AMC" className="w-12 h-12 object-contain" />
          <div>
            <div className="font-heading font-semibold text-slate-900">Afzal Medical</div>
            <div className="text-xs uppercase tracking-widest text-red-700">Admin Panel</div>
          </div>
        </div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900">Sign in</h1>
        <p className="text-sm text-slate-500 mt-1">Access the hospital admin dashboard.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
              data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
              data-testid="login-password" />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="login-submit">
            <LogIn className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
